import * as types from "./constants";

const performance = { data: null, error: "", success: false, loading: false };
const allTestResult = { data: null, error: "", success: false, loading: false };
const initialState = {
  performance: { ...performance },
  allTestResult: { ...allTestResult },
};

const performanceReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.GET_PERFORMANCE_TEST_RESULT:
      return { ...state, ...performance };
    case types.GET_PERFORMANCE_TEST_RESULT_LOADING:
      return { ...state, performance: { ...performance, loading: true } };
    case types.GET_PERFORMANCE_TEST_RESULT_SUCCESS:
      return {
        ...state,
        performance: { ...performance, data: payload, success: true },
      };
    case types.GET_PERFORMANCE_TEST_RESULT_ERROR:
      return { ...state, performance: { ...performance, error: payload } };
    case types.GET_ALL_USER_TEST_RESULT:
      return { ...state, ...allTestResult };
    case types.GET_ALL_USER_TEST_RESULT_LOADING:
      return { ...state, allTestResult: { ...allTestResult, loading: true } };
    case types.GET_ALL_USER_TEST_RESULT_SUCCESS:
      return {
        ...state,
        allTestResult: { ...allTestResult, success: true, data: payload },
      };
    case types.GET_ALL_USER_TEST_RESULT_ERROR:
      return { ...state, allTestResult: { ...allTestResult, error: payload } };
    default:
      return state;
  }
};

export default performanceReducer;
